import { Component, Input } from '@angular/core'
import { Event } from '../../models/event.model'

import * as moment from 'moment'
moment.locale('fr')

@Component({
  selector: 'ld-event-date',
  template: require('./event-date.component.html'),
  styles: [require('./event-date.component.css')]
})
export class EventDateComponent {
  @Input('event') event: Event
  @Input('currentYear') currentYear = moment().year()
  private displayedBeginAt: moment.Moment
  private displayedEndAt: moment.Moment

  ngOnChanges () {
    if (!this.event.beginAt || !this.event.endAt) return

    this.displayedBeginAt = this.event.beginAt.clone()
    this.displayedEndAt = this.event.endAt.clone()

    if (this.event.recurring) {
      this.displayedBeginAt.year(this.currentYear)
      this.displayedEndAt.year(this.currentYear)
    }
  }

  dateInterval () {
    if (!this.event.beginAt || !this.event.endAt) return

    if (this.event.beginAt.isSame(this.event.endAt, 'day') && this.event.beginAt.isSame(this.event.endAt, 'hour')) {
      return 'same-hour'
    } else if (this.event.beginAt.isSame(this.event.endAt, 'day') && !this.event.beginAt.isSame(this.event.endAt, 'hour')) {
      return 'same-day'
    } else {
      return 'different-days'
    }
  }

  hasFirstOccurencePast () {
    return this.event.beginAt.isSameOrAfter(moment(), 'day')
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/event-date/event-date.component.ts